<template>
  <div id="box">
    <!-- 顶部起始位置 -->
    <historyTag :historyArr="historyArr"></historyTag>
    <!-- 顶部结束位置 -->

    <div id="mainBox">
      <div v-if="isPage == 'index'" class="body">

        <div class="flex">
          <ul class="topBox">
          
            <li class="flex">
              <div style="width: 240px">
                <el-input v-model="searchVle" placeholder="请输入"></el-input>
              </div>
            </li>

            <li class="flex" style="padding-top: 5px">
              <el-button type="success" size="small" @click="searchFn">搜索</el-button>


            </li>
          </ul>

        </div>


        <!-- 主体内容 -->
        <div>
          <el-table :data="tableData" border style="width: 100%; margin-top: 10px" @row-click="clickData">

            <el-table-column prop="id" width="100" align="center" label="ID">
            </el-table-column>
            <el-table-column type="index" align="center" label="头像" width="100">
              <template slot-scope="scope">
                <div>
                  <img :src="scope.row.photo" style="width: 45px; height: 45px" alt="" srcset="" />
                </div>
              </template>
            </el-table-column>


            <el-table-column prop="nickName" align="center" label="昵称">
            </el-table-column>

       

            <el-table-column prop="time" align="center" label="注册时间">
            </el-table-column>



            <el-table-column prop="time" align="center" label="注册时间">
            </el-table-column>
       

            <el-table-column prop="canFastIdentify" align="center" label="快速下单">
              <template slot-scope="scope">
                <el-switch
                  v-loading="scope.row.loading"
                  :value="scope.row.canFastIdentify"
                  :active-value="1"
                  :inactive-value="0"
                  @change="event=>onCanFastIdentifyChange(event,scope.row)"
                />
              </template>
            </el-table-column>

          </el-table>

          <div class="page_box">
            <el-pagination @current-change="changePage" :current-page.sync="currentPage" :page-size="pageSize"
              layout="total, prev, pager, next,jumper" :total="tableTotal">
            </el-pagination>
          </div>
        </div>
        <!-- 主体内容 -->
      </div>







    </div>
  </div>
</template>

<script>
import { delTips, returnTime } from "@/util/utils";


export default {
  components: {

  },
  data() {
    return {
      isPage: "index",

      dataList: {},

      surplusShow: 0,
      userList: "",

      // 历史记录
      historyArr: ["用户管理"],

      //  搜索
      searchVle: "",

      // 搜索类型
      searchType: 1,
      searchData: [
        {
          id: 1,
          name: "昵称",
        },
        {
          id: 2,
          name: "手机号",
        },
      ],

      // 数据信息
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      tableTotal: 0,

      // 用户密码
      delShow: 0, //删除提示
      delList: {},
      userPass: "",
    };
  },
  mounted() {
    this.selListFn(1);
  },
  methods: {
    onCanFastIdentifyChange(canFastIdentify,row){
      const data = {
        id: row.id,
        nickName: row.nickName,
        canFastIdentify,
      }
      this.tableData.find(item=>item.id == row.id).loading = true
      this.$https(this.$api.api.upUser, data, "POST")
      .then((res) => {
        console.log(res)
        if (res.data.code == 200) {
          this.tableData.find(item=>item.id == row.id).canFastIdentify = canFastIdentify
        }
      })
      .finally(e=>{
       this.tableData.find(item=>item.id == row.id).loading = false
      })
      
      console.log(data)
    },
    // 搜索
    searchFn: function (res) {
      this.selListFn(1);
      this.currentPage = 1;
    },

    clickData() {

    },

 



    // 查询
    selListFn: function (page) {
      var obj = {
        page: page,
        size: this.pageSize,
      };

      if (this.searchVle) {
        obj.nickName = this.searchVle;
      }

      this.$https(this.$api.api.selUser, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          var data = res.data.data;
          data.forEach(v => {
            v.time = v.createTime ? returnTime(new Date(v.createTime)) : "";

          });
          this.tableData = data.map(e=>{
            e.loading = false;
            return e
          });
          this.tableTotal = res.data.size;
        } else {
          this.tableData = [];
          this.tableTotal = 0;
        }
      });
    },

    // 返回
    returnFn(res) {
      this.selListFn(this.currentPage);
      this.isPage = "index";
      this.historyArr.pop();
    },

    // 分页
    changePage: function (res) {
      this.selListFn(res);
    },

    // 删除
    delFn: delTips(function (index) {
      var list = this.tableData[index];

      this.$https(
        this.$api.api.delUser,
        {

          id: list.id,
        },
        "GET"
      ).then((res) => {
        if (res.data.code == 200) {
          this.selListFn(this.currentPage);
          this.$message.success("操作成功");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    }),
  },
};
</script>

<style lang="less" scoped>
#box {
  width: 100%;

  .body {
    margin-top: 20px;
  }

  .top_right {
    display: flex;
  }

  .topBox {
    width: 100%;
    margin-top: 10px;
    overflow: hidden;
    font-size: 15px;

    li {
      float: left;
      margin-right: 20px;
      margin-bottom: 10px;

      .el-range-editor.el-input__inner {
        width: 290px;
      }
    }

    li:last-child {
      margin-right: 0px;
    }

    span {
      margin-right: 5px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/userAdmin/index.vue